import getTooltipShift from 'components/TooltipPositioner/getTooltipShift';
import React, {FC, ReactElement, useCallback, useEffect, useRef} from 'react';
import {padRect} from 'utils/domRect';

type Props = {
  target: HTMLElement | SVGElement | null;
  children: ReactElement;
};

const TooltipPositioner: FC<Props> = ({children, target}) => {
  const parentMargin = 10;
  const targetMargin = 10;
  const contentRef = useRef<HTMLDivElement | null>(null);
  const update = useCallback(() => {
    const tooltipElem = contentRef.current;
    const tooltipParent = tooltipElem?.parentElement;
    if (!target || !tooltipElem || !tooltipParent) {
      if (tooltipElem) tooltipElem.style.opacity = '0';
      return;
    }
    const parentRect = tooltipParent.getBoundingClientRect();
    const tooltipRect = tooltipElem.getBoundingClientRect();
    const targetRect = target.getBoundingClientRect();
    const tooltipNewRect = getTooltipShift(
      padRect(parentRect, -parentMargin),
      tooltipRect,
      targetRect,
      targetMargin,
    );
    tooltipElem.style.opacity = '1';
    tooltipElem.style.transform = `translate(${tooltipNewRect.left -
      parentRect.left}px, ${tooltipNewRect.top - parentRect.top}px)`;
  }, [target]);
  useEffect(() => {
    window.addEventListener('scroll', update);
    window.addEventListener('mousemove', update);
    return () => {
      window.removeEventListener('scroll', update);
      window.removeEventListener('mousemove', update);
    };
  });
  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        transform: `translate(0px, 0px)`,
        pointerEvents: 'none',
        opacity: 0,
      }}
      ref={e => {
        contentRef.current = e;
        update();
      }}
    >
      {children}
    </div>
  );
};

export default TooltipPositioner;
